export default __webpack_public_path__ + "static/media/m_video.aaa714bf.png";